const mEditionBillingMyPaymentsCancelSubscription = {
  mEditionBillingMyPaymentsCancelSubscription: {
    paragraph: {
      line1: 'Lo sentimos,',
      line2: 'no puedes',
      line3: 'cancelar',
      line4: 'una suscripción',
      line5: 'que aún no fue',
      line6: 'confirmada.',
      cancel: 'CANCELAR SUSCRIPCIÓN',
    },

    paragraphElse: {
      cancel: 'CANCELAR SUSCRIPCIÓN',
      line1: 'Ten en cuenta que al cancelar la suscripción a tu plan de Vidroop, ',
      line2: 'todos tus alumnos',
      line3: ' dejarán de ver tus formaciones.'
    },

    paragraphElseIf: {
      cancelled: 'Cancelada.',
      line1: 'La suscripción a tu plan fue',
      line2: 'Todos tus alumnos dejaron de ver tus formaciones.',
      line3: 'Podrás acceder hasta el día ',
      line4: 'Al llegar esa fecha, todos tus alumnos dejarán de ver tus formaciones.',
    },

    alerts: {
      updateSubscription: {
        error: 'Un error ha ocurrido. Verifica que la sucripción este activa.',
        success: 'Se canceló en forma exitosamente la suscripción.',
        successGateway: 'Solicitud de cancelación exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      }
    }
  }
}

export default mEditionBillingMyPaymentsCancelSubscription
